import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useDemoData } from './demoData';
import styles from './DemoDataNote.module.css';

/**
 * Linha discreta enquanto a conta tem dados de exemplo (R8): Estatísticas e
 * Início incluem o exemplo, a tela de planos avisa que ele sai ao assinar.
 */
function DemoDataNote({ children = 'Inclui dados de exemplo', className = '' }) {
  const { active } = useDemoData();
  if (!active) return null;
  return (
    <p className={`${styles.note} ${className}`}>
      <InfoOutlinedIcon fontSize="inherit" className={styles.icon} />
      {children}
    </p>
  );
}

export default DemoDataNote;
